// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-format-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.input-format-popup {
  background-color: white;
  border-radius: 8px;
  width: 80%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  animation: popupFadeIn 0.3s ease-out;
}

@keyframes popupFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.popup-header {
  position: sticky;
  top: 0;
  width: 100%;
  box-sizing: border-box;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f8f9fa;
  border-radius: 8px 8px 0 0;
}

.popup-header h2 {
  margin: 0;
  color: #333;
  font-size: 1.4rem;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  color: #666;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s;
}

.close-button:hover {
  background-color: rgba(0, 0, 0, 0.1);
  color: #333;
}

.popup-content {
  padding: 20px;
}

.format-instructions {
  margin-bottom: 30px;
}

.format-instructions h3,
.demo-file-section h3 {
  color: #2c3e50;
  margin-top: 0;
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
}

.format-instructions ul {
  padding-left: 20px;
}

.format-instructions li {
  margin-bottom: 8px;
  line-height: 1.5;
}

.file-format-example {
  background-color: #f5f5f5;
  padding: 15px;
  border-radius: 4px;
  border-left: 4px solid #007bff;
  font-family: monospace;
  white-space: pre-wrap;
  overflow-x: auto;
  font-size: 0.9rem;
  margin: 15px 0;
}

.demo-file-section {
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
}

.download-demo-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
  margin: 10px 0 20px 0;
}

.download-demo-button:hover {
  background-color: #0069d9;
}

.screenshot-container {
  margin-top: 20px;
  text-align: center;
}

.screenshot-container h4 {
  font-size: 1rem;
  margin-bottom: 10px;
}

.demo-screenshot {
  max-width: 100%;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.screenshot-caption {
  font-size: 0.85rem;
  color: #666;
  margin-top: 8px;
} `, "",{"version":3,"sources":["webpack://./src/css/step1_InputFormatPopup.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,sBAAsB;EACtB,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB","sourcesContent":[".input-format-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.input-format-popup {\n  background-color: white;\n  border-radius: 8px;\n  width: 80%;\n  max-width: 800px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);\n  animation: popupFadeIn 0.3s ease-out;\n}\n\n@keyframes popupFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.popup-header {\n  position: sticky;\n  top: 0;\n  width: 100%;\n  box-sizing: border-box;\n  z-index: 2;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  border-bottom: 1px solid #e0e0e0;\n  background-color: #f8f9fa;\n  border-radius: 8px 8px 0 0;\n}\n\n.popup-header h2 {\n  margin: 0;\n  color: #333;\n  font-size: 1.4rem;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #666;\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.close-button:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n  color: #333;\n}\n\n.popup-content {\n  padding: 20px;\n}\n\n.format-instructions {\n  margin-bottom: 30px;\n}\n\n.format-instructions h3,\n.demo-file-section h3 {\n  color: #2c3e50;\n  margin-top: 0;\n  margin-bottom: 15px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 8px;\n}\n\n.format-instructions ul {\n  padding-left: 20px;\n}\n\n.format-instructions li {\n  margin-bottom: 8px;\n  line-height: 1.5;\n}\n\n.file-format-example {\n  background-color: #f5f5f5;\n  padding: 15px;\n  border-radius: 4px;\n  border-left: 4px solid #007bff;\n  font-family: monospace;\n  white-space: pre-wrap;\n  overflow-x: auto;\n  font-size: 0.9rem;\n  margin: 15px 0;\n}\n\n.demo-file-section {\n  background-color: #f9f9f9;\n  padding: 20px;\n  border-radius: 6px;\n  border: 1px solid #e0e0e0;\n}\n\n.download-demo-button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s;\n  margin: 10px 0 20px 0;\n}\n\n.download-demo-button:hover {\n  background-color: #0069d9;\n}\n\n.screenshot-container {\n  margin-top: 20px;\n  text-align: center;\n}\n\n.screenshot-container h4 {\n  font-size: 1rem;\n  margin-bottom: 10px;\n}\n\n.demo-screenshot {\n  max-width: 100%;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n.screenshot-caption {\n  font-size: 0.85rem;\n  color: #666;\n  margin-top: 8px;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
